import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Title, TextBody } from 'web-ui-components/lib/atoms/text';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { ServicingSection } from 'web-ui-components/lib/global/layout';
import { ButtonGroup } from 'web-ui-components/lib/molecules/buttons';
import { BackButton } from 'web-ui-components/lib/molecules/navigation';
import { Popover } from 'web-ui-components/lib/atoms/popovers';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import {
	showAllErrors,
	updateValidation,
	hideErrorMsg,
	deleteValidationField,
} from '../../../states/validation/actions';
import { getValidationsForAddInternationalPayee, isSpecificFormValid } from '../../../states/validation/selectors';
import { updateAddPayeeForm, resetAddPayeeForm, resetAddPayeeFormErrors } from '../../states/addPayee/actions';
import {
	getAddPayeeFormDetails,
	getErrors,
	getLinkAccountDetails,
	isPaymentFlow,
	showSingleUseBox,
	getEditPayeeButtonStatus,
} from '../../states/addPayee/selectors';
import {
	errorsPropTypes,
	addInternationalPayeeFormPropTypes,
	internationalAddPayeevalidationPropTypes,
	linkAccountDetailsPropTypes,
} from '../../states/addPayee/propTypes';
import { getBankId } from '../../../states/session/selectors';
import { addPayeeFormFormatter, spacesCheck } from '../../../utils/payeeUtils';
import { default as pageContent, contentPropTypes } from '../AddNewPayeeLandingPage/index.content';
import AddPayeeFormErrors from '../AddPayeeForm/AddPayeeFormErrors';
import AddressForm from './AddressForm';
import PaymentDetailsForm from './PaymentDetailsForm';
import { NameInput, DisplayNameInput, PayeeAddressLine1, PayeeCity, PayeeCountry } from './withValidationComponents';
import withContent from '../../../containers/withContent';
import { goBackPage } from '../../../states/page/actions';
import { hasApiCallInProgress } from '../../../states/api/selectors';
import Checkbox from '../../../sharedComponents/Form/Checkbox/index';

const mapState = (state, props) => ({
	validations: getValidationsForAddInternationalPayee(state, props.isEditPayee),
	addPayeeForm: getAddPayeeFormDetails(state),
	formValid: isSpecificFormValid(state, props.id),
	bankId: getBankId(state),
	errors: getErrors(state),
	linkAccountDetails: getLinkAccountDetails(state, props.accountsForAddPayee),
	hasApiCallInProgress: hasApiCallInProgress(state),
	isPaymentFlow: isPaymentFlow(state),
	showSingleUseBox: showSingleUseBox(state, props.isEditPayee),
	isEditPayeeButtonDisabled: getEditPayeeButtonStatus(state),
});

const mapDispatch = (dispatch, props) => ({
	showAllErrors: () => dispatch(showAllErrors(props.id)),
	updateValidation: (key, isValid, isFocusOn, isBackEndError, showValidation) =>
		dispatch(updateValidation({ id: props.id, key, isValid, isFocusOn, isBackEndError, showValidation })),
	hideErrorMsg: (key) => dispatch(hideErrorMsg({ id: props.id, key })),
	updateAddPayeeForm: (value) => dispatch(updateAddPayeeForm(value)),
	deleteValidationField: (id, fieldId) => dispatch(deleteValidationField(id, fieldId)),
	resetAddPayeeForm: () => dispatch(resetAddPayeeForm()),
	resetAddPayeeFormErrors: () => dispatch(resetAddPayeeFormErrors()),
	goBackPage: () => dispatch(goBackPage()),
});
export class AddInternationalPayeeForm extends Component {
	constructor(props) {
		super(props);
		this.updateAddPayeeForm = this.updateAddPayeeForm.bind(this);
		this.noBicOrSwiftChange = this.noBicOrSwiftChange.bind(this);
		this.payeeAccountChange = this.payeeAccountChange.bind(this);
		this.handleSingleUseChange = this.handleSingleUseChange.bind(this);
		this.state = {
			showMoreInfo: false,
		};
	}
	componentWillReceiveProps(newProps) {
		const {
			errors: { showError },
		} = this.props;
		const isBackEndError = newProps.errors.showError && !showError;
		if (isBackEndError && window && window.scrollTo) {
			window.scrollTo(0, 0);
		}
	}
	componentDidUpdate() {
		const {
			errors: { showError },
		} = this.props;
		if (showError && window && window.scrollTo) {
			window.scrollTo(0, 0);
		}
	}
	componentWillUnmount() {
		const { resetAddPayeeForm } = this.props;
		resetAddPayeeForm();
	}
	updateAddPayeeForm(event) {
		const { updateAddPayeeForm, addPayeeForm } = this.props;
		const {
			target: { id, value },
		} = event;
		const formattedValue = addPayeeFormFormatter[id] ? addPayeeFormFormatter[id](event, addPayeeForm) : value;
		if (addPayeeForm[id] !== formattedValue) {
			updateAddPayeeForm({ [id]: formattedValue });
		}
	}
	noBicOrSwiftChange({ target: { id, checked } }) {
		const { updateAddPayeeForm, deleteValidationField, updateValidation } = this.props;
		updateAddPayeeForm({ [id]: checked });
		if (checked) {
			updateAddPayeeForm({ bickOrSwift: '' });
			deleteValidationField(this.props.id, 'bickOrSwift');
		}
		if (!checked) {
			updateValidation('bickOrSwift', false);
			updateAddPayeeForm({
				bankName: '',
				bankAddressLine1: '',
				bankAddressLine2: '',
				bankCity: '',
				bankPostalCode: '',
				bankCountry: '',
			});
			deleteValidationField(this.props.id, ['bankName', 'bankAddressLine1', 'bankCity', 'bankCountry']);
		}
	}
	payeeAccountChange({ target: { id, name } }) {
		const { updateAddPayeeForm, deleteValidationField } = this.props;
		updateAddPayeeForm({ [name]: id });
		if (id === 'accono') {
			updateAddPayeeForm({ iban: '' });
			deleteValidationField(this.props.id, 'iban');
		}
		if (id === 'iban') {
			updateAddPayeeForm({
				internationalAccountNumber: '',
				bickOrSwift: '',
				noBicOrSwift: false,
				clearingCode: '',
				bankName: '',
				bankAddressLine1: '',
				bankAddressLine2: '',
				bankCity: '',
				bankPostalCode: '',
				bankCountry: '',
			});
			deleteValidationField(this.props.id, [
				'internationalAccountNumber',
				'bickOrSwift',
				'bankName',
				'bankAddressLine1',
				'bankCity',
				'bankCountry',
			]);
		}
	}
	handleSingleUseChange({ target }) {
		const { updateAddPayeeForm, deleteValidationField, id } = this.props;
		updateAddPayeeForm({ [target.id]: !target.checked });
		deleteValidationField(id, 'displayName');
	}
	render() {
		const {
			content: {
				addInternationalPayeeHeader,
				payeeDetailsTitle,
				nameLabel,
				displayNameLabel,
				displayNameDescription,
				backButtonLabel,
				addPayeeLabel,
				payeeAddressTitle,
				postalCodeDescription,
				saveInPayeeListLabel,
				saveInPayeeListDescription,
				editPayeeLabel,
				editPayeeHeader,
				moreInfoText,
			},
			validations,
			updateValidation,
			hideErrorMsg,
			addPayeeForm,
			updateAddPayeeForm,
			errors,
			resetAddPayeeFormErrors,
			goBackPage,
			hasApiCallInProgress,
			showSingleUseBox,
			isEditPayee,
			isEditPayeeButtonDisabled,
			handleAddInternationalPayeeSubmit,
		} = this.props;
		const validationProps = {
			validations,
			updateValidation,
			hideErrorMsg,
			onChange: this.updateAddPayeeForm,
			onFocusCheck: false,
		};
		const {
			internationalPayeeName,
			displayName,
			payeeAddressLine1,
			payeeAddressLine2,
			payeeCity,
			payeePostalCode,
			payeeCountry,
			iban,
			payeeAccountType,
			internationalAccountNumber,
			paymentReason,
			bickOrSwift,
			clearingCode,
			noBicOrSwift,
			bankAddressLine1,
			bankAddressLine2,
			bankCity,
			bankPostalCode,
			bankCountry,
			bankName,
			singleUse,
		} = addPayeeForm;
		if (Object.keys(addPayeeForm).length === 0) return null;
		const { showMoreInfo } = this.state;
		return (
			<ServicingSection>
				<BackButton onClick={goBackPage} disabled={hasApiCallInProgress} />
				<Title size="h1">{isEditPayee ? editPayeeHeader : addInternationalPayeeHeader}</Title>
				<Title size="h2">{payeeDetailsTitle}</Title>
				{errors.showError && (
					<AddPayeeFormErrors errorCode={errors.errorCode} resetAddPayeeFormErrors={resetAddPayeeFormErrors} />
				)}
				{showSingleUseBox && (
					<span>
						<Checkbox
							id="singleUse"
							label={saveInPayeeListLabel}
							onChange={this.handleSingleUseChange}
							checked={!singleUse}
						/>
						<TextBody>
							{saveInPayeeListDescription}
							<Popover
								id="popover-more-info"
								isOpen={showMoreInfo}
								content={moreInfoText}
								onClick={() => this.setState({ showMoreInfo: !showMoreInfo })}
							>
								<Icon iconType="InfoOutlineLarge" size="xs" />
							</Popover>
						</TextBody>
					</span>
				)}
				<NameInput
					id="internationalPayeeName"
					label={nameLabel}
					type="text"
					internationalPayeeName={internationalPayeeName}
					value={internationalPayeeName}
					onBlur={({ target: { id, value } }) => updateAddPayeeForm({ [id]: spacesCheck(value) })}
					{...validationProps}
				/>
				{!singleUse && (
					<DisplayNameInput
						id="displayName"
						label={displayNameLabel}
						type="text"
						description={displayNameDescription}
						displayName={displayName}
						value={displayName}
						onBlur={({ target: { id, value } }) => updateAddPayeeForm({ [id]: spacesCheck(value) })}
						{...validationProps}
					/>
				)}
				<Title size="h2">{payeeAddressTitle}</Title>
				<AddressForm
					validationProps={validationProps}
					addressLine1={{
						id: 'payeeAddressLine1',
						value: payeeAddressLine1,
						payeeAddressLine1,
						component: PayeeAddressLine1,
					}}
					addressLine2={{ id: 'payeeAddressLine2', value: payeeAddressLine2, payeeAddressLine2 }}
					city={{ id: 'payeeCity', value: payeeCity, payeeCity, component: PayeeCity }}
					postalCode={{
						id: 'payeePostalCode',
						value: payeePostalCode,
						payeePostalCode,
						description: postalCodeDescription,
					}}
					country={{ id: 'payeeCountry', value: payeeCountry, payeeCountry, component: PayeeCountry }}
				/>
				<PaymentDetailsForm
					validationProps={validationProps}
					iban={{ id: 'iban', value: iban, iban }}
					internationalAccountNumber={{
						id: 'internationalAccountNumber',
						value: internationalAccountNumber,
						internationalAccountNumber,
					}}
					paymentReason={{ id: 'paymentReason', value: paymentReason }}
					bickOrSwift={{ id: 'bickOrSwift', value: bickOrSwift, bickOrSwift }}
					clearingCode={{ id: 'clearingCode', value: clearingCode, clearingCode }}
					bankName={{ id: 'bankName', value: bankName, bankName }}
					payeeAccountType={payeeAccountType}
					noBicOrSwift={noBicOrSwift}
					noBicOrSwiftChange={this.noBicOrSwiftChange}
					bankAddressLine1={bankAddressLine1}
					bankAddressLine2={bankAddressLine2}
					bankCity={bankCity}
					bankPostalCode={bankPostalCode}
					bankCountry={bankCountry}
					payeeAccountChange={this.payeeAccountChange}
				/>
				<ButtonGroup>
					<Button display="secondary" width="flush" onClick={goBackPage} disabled={hasApiCallInProgress}>
						{backButtonLabel}
					</Button>
					<Button
						display="primary"
						width="flush"
						onClick={handleAddInternationalPayeeSubmit}
						isLoading={hasApiCallInProgress}
						disabled={isEditPayee && isEditPayeeButtonDisabled}
					>
						{isEditPayee ? editPayeeLabel : addPayeeLabel}
					</Button>
				</ButtonGroup>
			</ServicingSection>
		);
	}
}

AddInternationalPayeeForm.propTypes = {
	id: PropTypes.string.isRequired,
	content: PropTypes.shape(contentPropTypes).isRequired,
	showAllErrors: PropTypes.func.isRequired,
	validations: PropTypes.shape(internationalAddPayeevalidationPropTypes).isRequired,
	updateValidation: PropTypes.func.isRequired,
	hideErrorMsg: PropTypes.func.isRequired,
	updateAddPayeeForm: PropTypes.func.isRequired,
	addPayeeForm: PropTypes.shape(addInternationalPayeeFormPropTypes).isRequired,
	bankId: PropTypes.string.isRequired,
	deleteValidationField: PropTypes.func.isRequired,
	errors: errorsPropTypes,
	resetAddPayeeForm: PropTypes.func.isRequired,
	resetAddPayeeFormErrors: PropTypes.func.isRequired,
	formValid: PropTypes.bool.isRequired,
	linkAccountDetails: PropTypes.shape(linkAccountDetailsPropTypes).isRequired,
	goBackPage: PropTypes.func.isRequired,
	hasApiCallInProgress: PropTypes.bool.isRequired,
	isPaymentFlow: PropTypes.bool.isRequired,
	isEditPayee: PropTypes.bool.isRequired,
	showSingleUseBox: PropTypes.bool.isRequired,
	showLinkAccount: PropTypes.bool.isRequired,
	isEditPayeeButtonDisabled: PropTypes.bool.isRequired,
	handleAddInternationalPayeeSubmit: PropTypes.func.isRequired,
};

export default connect(mapState, mapDispatch)(withContent({ content: pageContent })(AddInternationalPayeeForm));
